module.exports = __webpack_public_path__ + "img/image160.8a14265a.jpg";